import React from "react";
import PropTypes from "prop-types";

const SidebarTitle = ({ title, from = "" }) => {
    return (
        <React.Fragment>
            {from == "news" ? (
                <h2 className="widget-title">{title}</h2>
            ) : (
                <h1 className="widget-title">{title}</h1>
            )}
        </React.Fragment>
    );
};

SidebarTitle.propTypes = {
    title: PropTypes.string,
    from: PropTypes.string,
};

export default SidebarTitle;
